// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import AlertTriangleFill from "@store/Library/Components/Toolkit/Icons/AlertTriangle/AlertTriangleFill";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import merge from "lodash/merge";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const enum fields {
    content = "content",
}

const mapStateToProps = (state: ApplicationState) => ({
    session: getSession(state),
});

interface OwnProps extends WidgetProps {
    fields: {
        [fields.content]: string;
    };
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface MaintenanceBannerStyles {
    bannerWrapper?: InjectableCss;
    bannerContent?: InjectableCss;
    bannerIcon?: IconPresentationProps;
}

const maintenanceBannerStyles: MaintenanceBannerStyles = {
    bannerWrapper: {
        css: css`
            background: ${getColor("warning.contrast")};
            border: 1px solid ${getColor("warning")};
            padding: ${pxToRem(10)};
            top: 0;
            width: 100%;
            z-index: ${x => x.theme.zIndex.menu};
        `,
    },
    bannerContent: {
        css: css`
            ${x => siteWidthStyles(merge([], x.theme.design.layout.spacing.side, [0, 0, 0, pxToRem(45)]))}
            display: flex;
            justify-content: center;
            align-items: center;
        `,
    },
    bannerIcon: {
        size: 30,
        css: css`
            color: ${getColor("warning")};
            margin-right: ${pxToRem(10)};
        `,
    },
};

export const MaintenanceBanner: React.FunctionComponent<Props> = ({ fields, session }) => {
    if (!fields.content || session.properties.erpServicesAvailable === "true") {
        return null;
    }

    const styles = maintenanceBannerStyles;

    const parsedContent = parse(fields.content, parserOptions);
    const [isSticky, setSticky] = useState(false);
    const handleScroll = () => {
        const windowScrollTop = window.scrollY;

        if (windowScrollTop > 0) {
            setSticky(true);
        } else {
            setSticky(false);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    return (
        <StyledWrapper {...styles.bannerWrapper} style={{ position: isSticky ? "fixed" : "relative" }}>
            <StyledWrapper {...styles.bannerContent}>
                <Icon {...styles.bannerIcon} src={AlertTriangleFill} />
                {parsedContent}
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(MaintenanceBanner),
    definition: {
        group: "Basic",
        icon: "text",
        fieldDefinitions: [
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
            },
        ],
    },
};

export default widgetModule;
